export default "__VITE_ASSET__bwyRr$QZ__"